import React from 'react';

import { SEO } from '../../shared/components/SEO';
import WhatsAppFloatingButton from '../WhatsAppFloatingButton';

import MarketingLandingNav, { MARKETING_NAV_TOP_OFFSET } from './MarketingLandingNav';
import MarketingPageFooter from './MarketingPageFooter';

interface MarketingPageShellProps {
  children: React.ReactNode;
  onNavigate?: (view: string) => void;
  activeView?: string;
  title: string;
  description: string;
  canonical: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

const MarketingPageShell: React.FC<MarketingPageShellProps> = ({
  children,
  onNavigate,
  activeView,
  title,
  description,
  canonical,
  jsonLd,
}) => (
  <div className="marketing-page-shell min-h-screen bg-white text-gray-900 dark:bg-[#19191A] dark:text-white">
    <SEO title={title} description={description} canonical={canonical} jsonLd={jsonLd} />
    <MarketingLandingNav
      onNavigate={onNavigate}
      activeView={activeView}
      variant="funnel"
    />
    <main className={`${MARKETING_NAV_TOP_OFFSET} pb-12`}>{children}</main>
    <MarketingPageFooter onNavigate={onNavigate as never} theme="home" />
    <WhatsAppFloatingButton />
  </div>
);

export default MarketingPageShell;
